import React, { useState, useEffect } from "react";
import { Modal as ModalComponent, closeModal } from "../Modal.jsx";
import LoadingIndicator from "../loading_indicator.jsx";
import ProjectSelectorList from './ProjectSelectorList.jsx';
import { Portal } from "../Portal.jsx";

import { monitoring_report_project_selector_columns_path } from '~/routes';

const MODAL_ID = "project-selector-modal";

function ProjectSelectorModal({handleOpenModal, handleSaveModal, selectedItems = [], rowSelectionMode}) {
    const [selected, setSelected] = useState([]);

    const handleClose = () => {
        handleOpenModal();
        closeModal(MODAL_ID);
    }

    const handleSave = (e) => {
        handleSaveModal(selected);
        handleClose();
    };

    const handleSelectedData = (data) => {
        setSelected(data);
    }

    const [sortedColumns, setSortedColumns] = useState([]);
    const [defaultVisibleColumns, setDefaultVisibleColumns] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loading)
            jQuery.getJSON(
                monitoring_report_project_selector_columns_path(),
                (res) => {
                    setSortedColumns(res.sorted_columns);
                    setDefaultVisibleColumns(res.default_visible_columns);
                    setLoading(false);
                }
            );
    }, [loading]);

    return (<>
        <Portal
            id={MODAL_ID}
            title={I18n.t("select_projects")}
            saveLabel={I18n.t("update")}
            onSave={handleSave}
            onClose={handleClose}
            hideButtons={false}
            size="lg"
            component={ModalComponent}
        >
            {
                loading ? <LoadingIndicator/> :
                    <ProjectSelectorList {...{ sortedColumns, defaultVisibleColumns, handleSelectedData, selectedItems, rowSelectionMode }} />
            }
        </Portal>
    </>);
}

export default ProjectSelectorModal;
